export default __webpack_public_path__ + "static/media/community1-mirror.447e673f.png";